/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/


export default {
    UPDATE_AUTHENTICATED_USER(state, user) {
        localStorage.setItem('userInfo', JSON.stringify(user));
        localStorage.setItem('userRole', JSON.stringify(user.role));
    },
}
